module.exports = __webpack_public_path__ + "img/02.9b468e7f.jpg";